import { render, staticRenderFns } from "./RevenueByCoursePanel.vue?vue&type=template&id=6804db18&scoped=true"
import script from "./RevenueByCoursePanel.vue?vue&type=script&lang=js"
export * from "./RevenueByCoursePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6804db18",
  null
  
)

export default component.exports